/**
* ProblemLinkingCommandEvent.js
* 
* Created on 4-nov-2013
*
* @author Olivier van der Pool for Ranj
**/

export default class ProblemLinkingCommandEvent {
    constructor(type) {
        this.type = type;
    }
}

ProblemLinkingCommandEvent.PROBLEM_LINKING_SUBMITTED = "ProblemLinkingCommandEvent.PROBLEM_LINKING_SUBMITTED";


